import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { navItems } from '../../vertical/sidebar/sidebar-data';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { BrandingComponent } from '../../vertical/sidebar/branding.component';
import { CommonModule, NgFor, NgForOf, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from 'src/app/@auth/auth.service';
import { AuthSessionDto, AuthSessionDtoFO, ROLE_WORKSPACE_USER } from 'src/app/app.models';
import { CluLockscreenService, LOCKSCREEN_MODE } from 'src/app/utils/clu-lockscreen/clu-lockscreen.service';
import { CashDeskCoreRxDbService } from 'src/app/@clu-fe/apps/m-cashdesk/@services/m-cashdesk-core-rxdb.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RxPDeviceDocumentType } from 'src/app/@clu-fe/apps/m-cashdesk/@schemas/p_device.schema';
import { RxPDeviceDocument } from 'src/app/@clu-fe/apps/m-cashdesk/@services/m-cashdesk-core-rxdb';
import { MdAboutComponent } from '../../md-about/md-about.component';
import { AppService } from 'src/app/services/app.service';
import { CluGhostModeFnsDialogService } from 'src/app/utils/clu-ghostmode-fns-dialog/clu-ghostmode-fns-dialog.service';
import { CluGhostModeFnsDialogModule } from 'src/app/utils/clu-ghostmode-fns-dialog/clu-ghostmode-fns-dialog.module';
import { CluPermissionModule } from 'src/app/utils/clu-permission/clu-permission.module';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { TauriService } from 'src/app/services/tauri/tauri.service';
import { CluConfirmDialogService } from 'src/app/utils/clu-confirm-dialog/clu-confirm-dialog.service';
import { ConnectorCashDeskSyncDownDaoService } from 'src/app/@clu-fe/apps/m-cashdesk/cashdesk-sync-down/connector-cashdesk-sync-down-dao.service';

interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-horizontal-header',
  standalone: true,
  imports: [RouterModule, TablerIconsModule, MaterialModule, BrandingComponent, NgFor, NgIf, CommonModule, TranslateModule, CluGhostModeFnsDialogModule, CluPermissionModule],
  templateUrl: './header.component.html',
})
export class AppHorizontalHeaderComponent implements OnInit, OnDestroy {
   @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  public selectedLanguage: any = {
    language: 'Français',
    code: 'fr',
    icon: 'assets/images/flag/icon-flag-fr.svg',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: 'assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: 'assets/images/flag/icon-flag-fr.svg',
    },
    {
      language: 'Arabe',
      code: 'ar',
      icon: 'assets/images/flag/icon-flag-ar.png',
    },
    {
      language: 'Espagnol',
      code: 'es',
      icon: 'assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Allemand',
      code: 'de',
      icon: 'assets/images/flag/icon-flag-de.svg',
    }
  ];
  currentCashdeskGID : string = localStorage.getItem('LS_FE_AUTH_CASHDESK_GID') || '';
  authSessionDto: AuthSessionDtoFO;
  currentModule : string = 'Caisse';
  appVersion: any;
  onComplete$ = new Subject<void>();
  isTauri = false;

  private _daoSub?: Subscription;
  isSyncInProgress: boolean = false;
  totalSteps: number = 0;
  completedSteps: number = 0;
  progressPercent: number = 0;

  constructor(
    public dialog: MatDialog,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private _snackbar : MatSnackBar,
    private cashDeskCoreRxDbService : CashDeskCoreRxDbService,
    private connectorCashDeskSyncDownDaoService: ConnectorCashDeskSyncDownDaoService,
    private cluGhostModeFnsDialogService: CluGhostModeFnsDialogService,
    private appService: AppService,
    private _confirmationService: CluConfirmDialogService,
    private _tauriService: TauriService
  ) {
    //translate.setDefaultLang('fr');
    let _language = localStorage.getItem('CAURIS_LINKUP_LANG') || 'fr';
    translate.setDefaultLang(_language);
    this.selectedLanguage = this.languages.find(_lang => _lang.code == _language);

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (val.url.includes('remdocs')) { this.currentModule = 'Documents'; }
        else if (val.url.includes('cashdesk')) { this.currentModule = 'Caisse'; }
        else { this.currentModule = 'Caisse'; }
      }
    });
    this.authSessionDto = authService.authenticatedSession$.value!;
    this.appVersion = appService.appVersion$.value;

    if (appService.isFrontofficeTestEnv) {
        this.apps = this.apps.filter(item => item.ON_TEST_ENV === true);
    }
    this.isTauri = this._tauriService.isTauri;
  }

  ngOnInit(): void {
    this.appService.onFOCashdeskChanged$.pipe(takeUntil(this.onComplete$)).subscribe((_cashdeskGID : string | null) => {
      this.currentCashdeskGID = _cashdeskGID || '';
    });

    this._daoSub = this.connectorCashDeskSyncDownDaoService.syncStepsObs$.subscribe(steps => {
      this.isSyncInProgress = Array.isArray(steps) && steps.some((s:any) => s && s.STATUS === 'inprogress');
      this.totalSteps = Array.isArray(steps) ? steps.length : 0;
      this.completedSteps = Array.isArray(steps) ? steps.filter((s:any) => s && s.STATUS && (s.STATUS === 'completed_success' || s.STATUS === 'completed_error')).length : 0;
      this.progressPercent = this.totalSteps > 0 ? Math.round((this.completedSteps / this.totalSteps) * 100) : 0;
    });
  }

  ngOnDestroy(): void {
    this._daoSub?.unsubscribe();
    this.onComplete$.next();
    this.onComplete$.complete();
  }

  async doMinimizeApp() {
    await this._tauriService.minimizeApp();
  }

  async doQuitApp() {
    const confirmation = await this._confirmationService.showConfirmDialog("Cauris Linkup", "Voulez-vous vraiment quitter l'application ?");
    if (confirmation == true) {
      await this._tauriService.quitApp();
    }
  }

  doLogout() {
    if (this.authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.USER_WORKSPACE) {
      this.authService.doSignoutFOAction();
      this.authService.doRemoveAuthSession();
      this.router.navigateByUrl('/login');
    } else if (this.authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.ADMIN_WORKSPACE || this.authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.SUPER_ADMIN_WORKSPACE) {
      this.authService.doSignoutAdminAction();
      this.authService.doRemoveAuthSession();
      this.router.navigateByUrl("/cluadmin/login");
    } else {
      this.authService.doRemoveAuthSession();
      this.router.navigateByUrl('/login');
    }
  }

  async doLockAccount() {
    this.authService.doLockSession();
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppHorizontalSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  openAboutDialog() {
    const dialogRef = this.dialog.open(MdAboutComponent, {
      width: '100%', maxWidth: '500px', minHeight: '750px', maxHeight: '750px', height : '100%',
      data: { }
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  onCashdeskPickedEvent(_permItem : any){
    localStorage.setItem('LS_FE_AUTH_CASHDESK_GID', _permItem.CAISSEGID);
    this.appService.onFOCashdeskChanged$.next(_permItem.CAISSEGID);
    //window.location.reload();
    this.reloadCurrentRoute();
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.dialog.closeAll();
    this.router.navigateByUrl('/apps', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    localStorage.setItem('CAURIS_LINKUP_LANG', lang.code);
    this.selectedLanguage = lang;
  }

  notifications: notifications[] = [
    {
      id: 1,
      img: '/assets/images/profile/user-1.jpg',
      title: 'Roman Joined the Team!',
      subtitle: 'Congratulate him',
    },
    {
      id: 2,
      img: '/assets/images/profile/user-2.jpg',
      title: 'New message received',
      subtitle: 'Salma sent you new message',
    },
    {
      id: 3,
      img: '/assets/images/profile/user-3.jpg',
      title: 'New Payment received',
      subtitle: 'Check your earnings',
    },
    {
      id: 4,
      img: '/assets/images/profile/user-4.jpg',
      title: 'Jolly completed tasks',
      subtitle: 'Assign her new tasks',
    },
    {
      id: 5,
      img: '/assets/images/profile/user-5.jpg',
      title: 'Roman Joined the Team!',
      subtitle: 'Congratulate him',
    },
  ];

  profiledd: profiledd[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-account.svg',
      title: 'My Profile',
      subtitle: 'Account Settings',
      link: '/',
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-inbox.svg',
      title: 'My Inbox',
      subtitle: 'Messages & Email',
      link: '/',
    },
    {
      id: 3,
      img: '/assets/images/svgs/icon-tasks.svg',
      title: 'My Tasks',
      subtitle: 'To-do and Daily Tasks',
      link: '/',
    },
  ];

  apps: any[] = [
    {
      id: 1,
      img: 'assets/images/svgs/module-caisse.png',
      title: 'Caisse',
      subtitle: 'Module caisse',
      link: '/apps/cashdesk/landing',
      PERMISSIONS: ["M_CAISSE"],
      ON_TEST_ENV: true
    },
    {
      id: 2,
      img: 'assets/images/svgs/module-saisie.png',
      title: 'Saisie décentralisée',
      subtitle: 'Module saisie décentralisée',
      link: '/apps/remdocs/landing',
      PERMISSIONS: ["M_REMDOCS"],
    }
    /*,
    {
      id: 3,
      img: 'assets/images/svgs/module-inventaire.png',
      title: 'Inventaire',
      subtitle: 'Module Inventaire',
      link: '/',
    },
    {
      id: 4,
      img: 'assets/images/svgs/module-mvts-caisse.png',
      title: 'Mouvements caisse',
      subtitle: 'Module caisse',
      link: '/',
    }*/
  ];

  quicklinks: quicklinks[] = [
    {
      id: 1,
      title: 'Pricing Page',
      link: '/',
    },
    {
      id: 2,
      title: 'Authentication Design',
      link: '/',
    },
    {
      id: 3,
      title: 'Register Now',
      link: '/',
    },
    {
      id: 4,
      title: '404 Error Page',
      link: '/',
    },
    {
      id: 5,
      title: 'Notes App',
      link: '/',
    },
    {
      id: 6,
      title: 'Employee App',
      link: '/',
    },
    {
      id: 7,
      title: 'Todo Application',
      link: '/',
    },
    {
      id: 8,
      title: 'Treeview',
      link: '/',
    },
  ];

  checkForMessages() {
    // #region Checks CASHDESK
    if(this.cashDeskCoreRxDbService && this.cashDeskCoreRxDbService.db && this.cashDeskCoreRxDbService.db.pdevice) {
      this.cashDeskCoreRxDbService.db.pdevice.findOne().exec().then((res : RxPDeviceDocument | null) => {
        if(res && res.CAISSE_SESSION_ETAT == 1){
          this.displaySnackbarErrorMessage('WARN', 'Votre caisse est ouverte. Pensez à effectuer votre clôture..')
        }
      });
    }
    // #endregion
  }

  private displaySnackbarErrorMessage(_type : string, _message : string, _duration?: number){
    let _panelClass : string = '';
    let _errorMessage : string = '';
    let _alert : { type: string; action: string; message: string } = { type   : 'success', action : 'SUCCES', message: '' };
    switch(_type){
        case "SUCCESS" : _alert.type = 'success'; _alert.action = 'SUCCES'; _panelClass = 'ccsuccess-snackbar'; _errorMessage = _message; break;
        case "ERROR" : _alert.type = 'error'; _alert.action = 'ERREUR'; _panelClass = 'ccerror-snackbar'; _errorMessage = _message; break;
        case "INFO" : _alert.type = 'info'; _alert.action = 'INFO'; _panelClass = 'ccinfo-snackbar'; _errorMessage = _message; break;
        case "WARN" : _alert.type = 'warn'; _alert.action = 'ATTENTION'; _panelClass = 'ccwarn-snackbar'; _errorMessage = _message; break;
    }
    this._snackbar.open(_errorMessage, _alert.action, { duration : _duration || 10000, panelClass : [_panelClass] });
  }

  ghostMode : boolean = localStorage.getItem('LS_FE_GHOST_MODE') == 'true' ? true : false;
  ghostMode_Counter : number = 0;
  toggleGhostMode() {
    if(this.ghostMode) { this.cluGhostModeFnsDialogService.openGhostModeFnsDialog().then((res : boolean) => { if(res) { this.ghostMode = false; localStorage.setItem('LS_FE_GHOST_MODE', this.ghostMode ? 'true' : 'false'); this.ghostMode_Counter = 0; } }); }
    this.ghostMode_Counter++;
    if(this.ghostMode_Counter > 10) {
      this.ghostMode = !this.ghostMode;
      localStorage.setItem('LS_FE_GHOST_MODE', this.ghostMode ? 'true' : 'false');
      this.ghostMode_Counter = 0;
    }
  }

}

@Component({
  selector: 'app-search-dialog',
  standalone: true,
  imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule, NgForOf],
  templateUrl: 'search-dialog.component.html',
})
export class AppHorizontalSearchDialogComponent {
  searchText: string = '';
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}
